// Fonte unica da regra "somente admin" usada pelo guard de rotas e pelo menu.
export const isAdminProfile = (user) => !!user && user.profile === "admin";

// Decide o destino do guard: true quando a rota adminOnly deve ser bloqueada.
// Usuario ainda nao carregado (nulo/sem profile) nao bloqueia, evitando loop/flash.
export const shouldBlockAdminOnly = (user) =>
  !!user && !!user.profile && user.profile !== "admin";

// Regras de Oportunidades por perfil. Admin tem tudo; user ve so o Kanban em
// somente leitura (backend devolve 403 em todo o resto). Usuario nao carregado
// fica restrito (nao dispara chamada admin).
export const getOpportunitiesViewRules = (user) => {
  const admin = isAdminProfile(user);
  return {
    showExtraTabs: admin,
    canMoveCards: admin,
    canRecalculate: admin,
    canEditKanbanFields: admin,
    // PUT /contatos/celular (SetCelularModal) é isAuth no backend (desde
    // D3-11c2): vale para user e admin. Usuário não carregado fica restrito.
    canSetCelular: !!user && !!user.profile,
  };
};
